import { api } from "..";

const endpoint = "/api/workorder";

// WORK ORDERS
export const getWorkOrderList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getWorkOrderDetail = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const addWorkOrder = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updateWorkOrder = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteWorkOrder = (id) => {
  return api.delete(`${endpoint}/${id}`);
}; 